import React from 'react'
import PageTitle from './include/PageTitle'
import Seo from '../Components/Seo'
const Team = () => {
    return (
        <div>
            <Seo
                title="QTECH Real Estate Team in Saudi Arabia"
                titleAr="فريق شركة تقنيات الجودة العقاري في السعودية"
                description="Meet the QTECH team delivering real estate brokerage, property management, marketing, maintenance, and development services in Saudi Arabia."
                descriptionAr="تعرف على فريق شركة تقنيات الجودة الذي يقدم خدمات الوساطة العقارية، إدارة الأملاك، التسويق العقاري، الصيانة، والتطوير العقاري في السعودية."
                keywords="QTECH team, real estate team Saudi Arabia, property management team"
                keywordsAr="فريق شركة تقنيات الجودة، فريق عقاري في السعودية، فريق عقاري في الخبر، إدارة أملاك، وساطة عقارية، تسويق عقاري"
                path="/team"
                image="/img/team/4.jpg"
            />
            <PageTitle titleKey="pages.team.title" currentPageKey="pages.team.title" bgImage="/img/bg/14.jpg" />




            <div className="ltn__team-area pt-110--- pb-90">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-4 col-sm-6">
                            <div className="ltn__team-item ltn__team-item-3---">
                                <div className="team-img">
                                    <img src="img/team/4.jpg" alt="Image" />
                                </div>
                                <div className="team-info">
                                    <h4>
                                        <a href="/team-details/1">Rosalina D. William</a>
                                    </h4>
                                    <h6 className="ltn__secondary-color">Real Estate Broker</h6>
                                    <div className="ltn__social-media">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-facebook-f" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-linkedin" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="ltn__team-item ltn__team-item-3---">
                                <div className="team-img">
                                    <img src="img/team/2.jpg" alt="Image" />
                                </div>
                                <div className="team-info">
                                    <h4>
                                        <a href="/team-details/2">Kelian Anderson</a>
                                    </h4>
                                    <h6 className="ltn__secondary-color">Selling Agents</h6>
                                    <div className="ltn__social-media">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-facebook-f" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-linkedin" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="ltn__team-item ltn__team-item-3---">
                                <div className="team-img">
                                    <img src="img/team/3.jpg" alt="Image" />
                                </div>
                                <div className="team-info">
                                    <h4>
                                        <a href="/team-details/3">Miranda H. Halim</a>
                                    </h4>
                                    <h6 className="ltn__secondary-color">Property Seller</h6>
                                    <div className="ltn__social-media">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-facebook-f" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-linkedin" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="ltn__team-item ltn__team-item-3---">
                                <div className="team-img">
                                    <img src="img/team/1.jpg" alt="Image" />
                                </div>
                                <div className="team-info">
                                    <h4>
                                        <a href="/team-details/4">Damble D. Browni.</a>
                                    </h4>
                                    <h6 className="ltn__secondary-color">Property Seller</h6>
                                    <div className="ltn__social-media">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-facebook-f" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-linkedin" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="ltn__team-item ltn__team-item-3---">
                                <div className="team-img">
                                    <img src="img/team/5.jpg" alt="Image" />
                                </div>
                                <div className="team-info">
                                    <h4>
                                        <a href="/team-details/5">Aiden Benjamin</a>
                                    </h4>
                                    <h6 className="ltn__secondary-color">Real Estate Broker</h6>
                                    <div className="ltn__social-media">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-facebook-f" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-linkedin" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-sm-6">
                            <div className="ltn__team-item ltn__team-item-3---">
                                <div className="team-img">
                                    <img src="img/team/6.jpg" alt="Image" />
                                </div>
                                <div className="team-info">
                                    <h4>
                                        <a href="/team-details/6">James Carter</a>
                                    </h4>
                                    <h6 className="ltn__secondary-color">Selling Agents</h6>
                                    <div className="ltn__social-media">
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-facebook-f" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-twitter" />
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fab fa-linkedin" />
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



        </div>
    )
}

export default Team